<template>
  <q-toolbar
    class="full-width justify-between q-px-none"
  >
    <div class="left row col-3 justify-between">
      <div>
        <q-btn
          data-testid="agenda-anterior"
          dense
          no-caps
          icon="mdi-chevron-left"
          unelevated
          flat
          color="blue-10"
          class="q-px-xs"
          @click="handleSetDay('prev')"
          style="border: 1px solid #0D47A1; border-radius: 6px 0px 0px 6px;border-right:0"
        />
        <q-btn
          data-testid="agenda-proximo"
          dense
          no-caps
          icon="mdi-chevron-right"
          color="blue-10"
          class="q-px-xs"
          @click="handleSetDay('next')"
          style="border: 1px solid #0D47A1; border-radius: 0px 6px 6px 0px;"
          flat
        />
      </div>
      <q-btn
        data-testid="agenda-hoje"
        dense
        no-caps
        label="Hoje"
        outline
        color="blue-10"
        class="q-px-sm"
        @click="handleSetDay('today')"
      />
    </div>

    <div class="center">
      <q-btn
        data-testid="agenda-selecionar-data"
        dense
        flat
        outline
        no-caps
        color="blu-10"
        persistent
        :label="viewTitleDate"
        no-icon-animation
        size="lg"
        class="text-bold"
      >
        <q-menu>
          <q-date
            data-testid="agenda-calendario-data"
            v-model="date"
            minimal
          >
            <div class="row items-center justify-end q-pa-none q-ma-none">
              <q-btn
                data-testid="agenda-calendario-ok"
                label="OK"
                color="black"
                outline
                unelevated
                dense
                round
                v-close-popup
              />
            </div>
          </q-date>
        </q-menu>
      </q-btn>
    </div>

    <div class="right col-5 row justify-between">
      <div class="row items-center">
        <q-btn
          data-testid="agenda-silenciar-notificacoes"
          v-if="showNotifications"
          dense
          unelevated
          color="red"
          icon="mdi-bell-outline"
          @click="toogleNotifications"
          outline
          square
          size="15px"
        >
          <q-tooltip>Silenciar notificações</q-tooltip>
        </q-btn>
        <q-btn
          data-testid="agenda-habilitar-notificacoes"
          v-else
          dense
          unelevated
          color="red"
          icon="mdi-bell-off-outline"
          size="15px"
          @click="toogleNotifications"
          outline
        >
          <q-tooltip>Habilitar notificações</q-tooltip>
        </q-btn>
        <q-separator
          vertical
          color="primary"
          class="q-mx-sm"
        />
        <q-btn
          data-testid="agenda-agendamentos-hoje"
          dense
          unelevated
          color="primary"
          icon="mdi-calendar-alert"
          size="15px"
          outline
          :disable="todayNotifications.length === 0"
        >
          <q-badge
            v-if="todayNotifications.length"
            color="red"
            floating
            rounded
            :label="todayNotifications.length"
          />
          <q-tooltip>Agendamentos</q-tooltip>
          <q-menu
            transition-show="jump-down"
            transition-hide="jump-up"
            v-model="showMenuTodayNotifications"
          >
            <div class="no-scroll">
              <q-btn
                data-testid="agenda-excluir-todos-hoje"
                flat
                no-caps
                dense
                v-if="todayNotifications.length"
                class=" text-blue-10 items-start cursor-pointer text-center text-bold bg-grey-1 full-width"
                @click="excludeAllNotification()"
              >
                Excluir todos os agendamentos de hoje
              </q-btn>
              <div
                v-else
                class="q-pa-sm text-black items-start cursor-pointer text-center text-blue-10 text-bold"
              >
                Nenhum agendamento para hoje
              </div>

              <div>
                <q-card-section
                  v-for="(notif, index) in todayNotifications"
                  :key="index"
                  class="row text-black items-center justify-between full-width"
                  style="border: 2px solid #f2f2f2;padding: 8px"
                >
                  <div
                    class="row"
                    style="border: 1px solid #f2f2f2; border-radius: 10px; width: 330px"
                  >
                    <div
                      class=" column col-3 text-grey-8 text-bold justify-center text-center q-pa-xs"
                      style="border-top-left-radius: 10px; border-bottom-left-radius: 10px; background-color: #f2f2f2;"
                    >
                      <span>{{ formatMonth() }}</span>
                      {{ formatHours(notif.start) }}
                    </div>
                    <div
                      class="column q-pa-xs"
                      style="width: 75%;"
                    >
                      <span
                        :data-testid="`agenda-editar-${notif.id}`"
                        class="text-bold q-mb-xs cursor-pointer"
                        style="font-size: 14px"
                        @click="emitToEdit(notif.id)"
                      >{{ notif.templateToSend? "Agendamento de envio de template": "Agendamento de evento" }}</span>
                      <span
                        :data-testid="`agenda-editar-titulo-${notif.id}`"
                        class="text-grey q-mb-xs cursor-pointer ellipsis"
                        style="height: 20px;  width: 100%; font-size: 12px"
                        @click="emitToEdit(notif.id)"
                      >{{ notif.notificationTitle }}
                      </span>
                      <div
                        class="row justify-end"
                      >
                        <q-btn
                          :data-testid="`agenda-excluir-${notif.id}`"
                          no-caps
                          unelevated
                          dense
                          color="red"
                          style="width: 68px"
                          padding="0px 10px"
                          label="Excluir"
                          @click="excludeNotification(notif.id)"
                        />
                      </div>
                    </div>
                  </div>
                </q-card-section>
              </div>
            </div>
          </q-menu>
        </q-btn>
      </div>
      <div>
        <q-btn
          data-testid="agenda-visao-mes"
          @click="setTypeCalendar('dayGridMonth')"
          dense
          flat
          label="Mês"
          no-caps
          color="blue-10"
          class="q-px-xs"
          outline
          style="border: 1px solid #0D47A1; border-radius: 3px 0px 0px 3px;border-right:0"
        />
        <q-btn
          data-testid="agenda-visao-semana"
          @click="setTypeCalendar('timeGridWeek')"
          dense
          class="q-px-sm"
          flat
          color="blue-10"
          no-caps
          label="Semana"
          outline
          style="border: 1px solid #0D47A1; border-radius: 0;"
        />
        <q-btn
          data-testid="agenda-visao-dia"
          @click="setTypeCalendar('timeGridDay')"
          dense
          flat
          color="blue-10"
          label="Dia"
          no-caps
          outline
          class="q-px-xs"
          style="border: 1px solid #0D47A1; border-radius: 0px 3px 3px 0px; border-left:0"
        />
      </div>
      <q-btn
        data-testid="agenda-fechar"
        dense
        unelevated
        color="blue-10"
        icon="mdi-home-outline"
        @click="goHome"
        outline
      >
        <q-tooltip>
          Fechar calendário
        </q-tooltip>
      </q-btn>
    </div>
  </q-toolbar>
</template>

<script>
import moment from 'moment-timezone'
import { mapGetters, mapState } from 'vuex'

moment.locale('pt-br')

export default {

  data () {
    return {
      date: '',
      viewTitleDate: moment(new Date()).format('MM / YYYY'),
      currentView: 'timeGridWeek',
      showNotifications: true,
      todayNotifications: [],
      showMenuTodayNotifications: false
    }
  },

  mounted () {
    this.date = moment(new Date()).format('YYYY-MM-DD')
    this.todayNotifications = this.notificationsForToday
  },
  computed: {
    ...mapGetters({
      notificationsForToday: 'calendarModule/todayNotifications'
    }),
    ...mapState({
      notifications: ({ calendarModule }) => calendarModule.notifications
    })

  },

  methods: {

    emitToEdit (id) {
      const calendarComponent = this.$parent.$refs.calendar.getApi()
      const events = calendarComponent.getEvents()
      const event = events.find(event => event.id === id)
      this.showMenuTodayNotifications = false
      this.$emit('open-to-edit', event)
    },

    async excludeNotification (id) {
      this.$q.dialog({
        title: 'Confirme a ação',
        message: 'Esta ação não poderá ser desfeita. Deseja continuar?',
        cancel: {
          label: 'Cancelar',
          color: 'primary'
        },
        ok: {
          label: 'Deletar',
          color: 'red-8'
        },
        persistent: true
      }).onOk(async () => {
        const newAppointments = await this.$store.dispatch('calendarModule/deleteAppointments', { idArray: [id] })
        this.$emit('update-schedule', newAppointments)
      })
    },

    async excludeAllNotification () {
      this.showMenuTodayNotifications = false
      const ids = this.todayNotifications.map(notif => notif.id)

      this.$q.dialog({
        title: 'Confirme a ação',
        message: 'Essa ação não poderá ser desfeita. Deseja continuar?',
        cancel: {
          label: 'Cancelar',
          color: 'primary'
        },
        ok: {
          label: 'Deletar',
          color: 'red-8'
        },
        persistent: true
      }).onOk(async () => {
        const newAppointments = await this.$store.dispatch('calendarModule/deleteAppointments', ({ idArray: ids }))
        this.$emit('update-schedule', newAppointments)
      })
    },

    formatDate (start) {
      return moment(start).format('DD/MM')
    },

    formatMonth () {
      const date = moment().format('MMM')
      return String(date).charAt(0).toUpperCase() + String(date).slice(1)
    },

    formatHours (unixTime) {
      return moment(unixTime * 1000).format('HH:mm')
    },

    handleSetDay (setDay) {
      const calendarComponent = this.$parent.$refs.calendar.getApi()

      if (setDay === 'today') calendarComponent.gotoDate(new Date())
      if (setDay === 'prev') calendarComponent.prev()
      if (setDay === 'next') calendarComponent.next()

      const currentDate = calendarComponent.getDate()
      const format = this.currentView === 'dayGridMonth'
        ? 'MMMM [de] YYYY'
        : 'D [de] MMMM [de] YYYY'
      this.viewTitleDate = moment(currentDate).format(format)
    },

    setTypeCalendar (type) {
      const calendarComponent = this.$parent.$refs.calendar.getApi()
      calendarComponent.changeView(type)
      this.currentView = type
      this.viewTitleDate = calendarComponent.currentData.viewTitle
    },

    toogleNotifications () {
      this.showNotifications = !this.showNotifications
      this.$store.dispatch('calendarModule/showNotifications', { notificationMode: this.showNotifications })
    },

    goHome () {
      this.$router.push('/attendances/attendances')
    }

  },

  watch: {
    date (date) {
      if (!date) return
      const calendarComponent = this.$parent.$refs.calendar.getApi()
      calendarComponent.gotoDate(new Date(date))
      this.viewTitleDate = calendarComponent.currentData.viewTitle
    },

    notificationsForToday () {
      this.todayNotifications = this.notificationsForToday
    }

  }
}

</script>

<style lang="sass">

</style>
